export default __webpack_public_path__ + "static/media/trr-drink-coffee-machiato.71f43717.png";